import fp from "lodash/fp";

import { mapSoftwareBillingInfo } from "hooks";

export default function mapSoftwareOptionsBillingInfoForm(formValues) {
	if (fp.isEmpty(formValues)) return;
	const mappedValues = {
		softwareOptionDefaults: mapSoftwareBillingInfo(formValues),
	};

	return mappedValues;
}
